import { ParamOrganizationSlug, ParamProjectSlug, ParamRegionUrl } from "./schema-DKEjeVqP.js";
import { defineTool } from "./define-SD6AQa4b.js";
import { apiServiceFromContext } from "./api-EaEPyKlQ.js";
import { structuredResult } from "./results-NF1RJbDZ.js";
import { assertProjectRefWithinConstraint } from "./project-constraints-DlfcU4mm.js";
import { z } from "zod";
import { setTag } from "@sentry/core";

//#region src/tools/catalog/delete-uptime-monitor.ts
const deleteUptimeMonitorOutputSchema = z.object({
	success: z.literal(true),
	uptimeMonitorId: z.string(),
	projectSlug: z.string()
});
var delete_uptime_monitor_default = defineTool({
	name: "delete_uptime_monitor",
	skills: ["project-management"],
	requiredScopes: ["project:write"],
	description: [
		"Delete a Sentry HTTP uptime monitor.",
		"",
		"Use this tool when you need to permanently remove an uptime monitor.",
		"",
		"Be careful when using this tool! Deletion cannot be undone.",
		"",
		"<examples>",
		"delete_uptime_monitor(organizationSlug='my-organization', projectSlug='backend', uptimeMonitorId='12345')",
		"</examples>"
	].join("\n"),
	inputSchema: {
		organizationSlug: ParamOrganizationSlug,
		regionUrl: ParamRegionUrl.nullable().default(null),
		projectSlug: ParamProjectSlug,
		uptimeMonitorId: z.string().trim().min(1).describe("Uptime monitor ID (detector id).")
	},
	annotations: {
		readOnlyHint: false,
		destructiveHint: true,
		idempotentHint: true,
		openWorldHint: true
	},
	outputSchema: deleteUptimeMonitorOutputSchema,
	async handler(params, context) {
		const apiService = apiServiceFromContext(context, { regionUrl: params.regionUrl ?? void 0 });
		const organizationSlug = params.organizationSlug;
		setTag("organization.slug", organizationSlug);
		setTag("project.slug", params.projectSlug);
		setTag("uptime.monitor_id", params.uptimeMonitorId);
		assertProjectRefWithinConstraint({
			resourceLabel: "Uptime monitor",
			scopedProjectSlug: context.constraints.projectSlug,
			project: { slug: params.projectSlug }
		});
		await apiService.deleteUptimeMonitor({
			organizationSlug,
			projectSlug: params.projectSlug,
			uptimeMonitorId: params.uptimeMonitorId
		});
		return structuredResult({
			success: true,
			uptimeMonitorId: params.uptimeMonitorId,
			projectSlug: params.projectSlug
		});
	}
});

//#endregion
export { deleteUptimeMonitorOutputSchema, delete_uptime_monitor_default };
//# sourceMappingURL=delete-uptime-monitor-CHj4Cluv.js.map